// extracted by mini-css-extract-plugin
export var container = "_7x-0";
export var icon = "_7x-1";
export var text = "_7x-2";